const styles = theme => ({
  modalRoot: {
    width: 700
  },
  modalBody: {
    padding: [[0, '!important']]
  },
  modalFooter: {
    marginTop: [[0, '!important']]
  },
  titleContainer: {
    // marginBottom: `${theme.spacing.unit * 4.125}px !important`,
    alignItems: 'center',
    borderBottom: '1px solid rgba(12,31,44,0.12)',
    display: 'flex',
    height: 56,
    padding: [[0, theme.spacing.unit * 12, 0, theme.spacing.unit * 2]],
    position: 'relative'
  },
  bodyContainer: {
    padding: [[theme.spacing.unit * 4, 0, 0, theme.spacing.unit * 4]]
  },
  title: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  fieldsMarginBottom: {
    marginBottom: `${theme.spacing.unit * 2.5}px !important`
  },
  emptyPreview: {
    backgroundColor: '#F5F6F7',
    width: '100%',
    height: 300,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center'
  },
  form: {
    height: 148
  },
  prevFileButton: {
    position: 'absolute',
    right: 42
  },
  nextFileButton: {
    position: 'absolute',
    right: 4
  },
  fileTypeIcon: {
    fontSize: 72,
    color: 'rgba(12,31,44,0.12)'
  },
  openInNewTabButton: {
    position: 'absolute',
    bottom: 4,
    right: 4
  },
  previewContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFF',
    width: '80.18%',
    height: 276,
    border: '1px solid rgba(12,31,44,0.12)',
    borderBottom: 0,
    position: 'relative',
    top: 24
  },
  loadingMoreFilesContainer: {
    position: 'absolute',
    width: 40,
    height: 40,
    right: 14
  },
  loadingMoreFilesIcon: {
    height: [24, '!important'],
    width: [24, '!important']
  }
});

export default styles;
